/**
 * Types for Reel Video Captions feature
 */

/** Caption position on the video */
export type CaptionPosition = 'auto' | 'top' | 'middle' | 'bottom';

/** Global caption settings stored on the reel */
export interface ICaptionSettings {
  enabled: boolean;
  borderColor: string;
  position: CaptionPosition;
}

/** Default caption settings for new reels */
export const DEFAULT_CAPTION_SETTINGS: ICaptionSettings = {
  enabled: true,
  borderColor: '#FFD700',
  position: 'auto',
};

/** Preset color swatches for the caption border color picker */
export const CAPTION_BORDER_COLOR_PRESETS: readonly string[] = [
  '#FFD700', // Gold
  '#FF4444', // Red
  '#4488FF', // Blue
  '#44BB44', // Green
  '#AA44FF', // Purple
  '#00CCCC', // Cyan
  '#FFFFFF', // White
  '#000000', // Black
] as const;

/** Word-level timestamp from ElevenLabs TTS */
export interface IWordTimestamp {
  word: string;
  startMs: number;
  endMs: number;
}
